import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionGoogleSlidesProperty = (
  target: CompatibilitySlide<'google-slides'> | VotingSlide<'google-slides'>,
  prop: keyof Question,
) => {
  const staticContents = target.staticContent;

  switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
    case 'question':
      return target.title;
    case 'module_custom_data':
      return {
        google_slides_url: staticContents.url,
        starting_slide_number: staticContents.startingSlideNumber,
      };
    default:
      return undefined;
  }
};
